import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError,  map, switchMap, } from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import { SendBackResult} from '../../shared';
import {of} from 'rxjs';
import {
  contractDuplicateActionTypes,
  DuplicationContractAction,
  DuplicationContractFailAction,
  DuplicationContractSuccessAction
} from '../actions/contract-duplication';
import {Contract} from '../../contract/models/contract';
import {ContractService} from '../../contract/services/contract.service';
import {ContractMapperService} from '../../contract/services/contract-mapper.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class ContractDuplicationEffect extends BaseEffect {

  add$ = createEffect(() => { return this.actions$.pipe(
    ofType(contractDuplicateActionTypes.DUPLICATE),
    debug('add contract action received.'),
    map((action: DuplicationContractAction) => action.payload),
    switchMap((payload) =>  this.contractService.add(payload.companyUuid,
      this.contractMapperService.contractFormToDb(payload.contractForm)).pipe(
      switchMap((data: SendBackResult<Contract>) => of( new DuplicationContractSuccessAction(data.data) )),
      catchError(res => this.catchResponseError(res))))
  ) });

  addSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(contractDuplicateActionTypes.DUPLICATE_SUCCESS),
    debug('add success contract action received.'),
    switchMap((data) => [
      success(this.translation.translate('CONTRACT_DUPLICATION_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  ) });


  addFail$ = createEffect(() => { return this.actions$.pipe(ofType(contractDuplicateActionTypes.DUPLICATE_FAIL),
    debug('A server error occurred while add contract.'),
    map((err: DuplicationContractFailAction) =>
      error(this.translation.translate('CONTRACT_DUPLICATION_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private contractService: ContractService,
              private contractMapperService: ContractMapperService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new DuplicationContractFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new DuplicationContractFailAction(response['error'].message);
  }
}
